/* ============================================================
   product-content.js — PDP içerik etkileşimleri (Dalga 2)
   ------------------------------------------------------------
   1) Accordion   : native <details> kendi çalışır; ekstra olarak
                    [data-accordion] / [data-accordion-trigger] desteği
                    (max-height animasyonu, max bir açık).
   2) Research    : [data-research-more] → gizli kartları açığa çıkar
                    (JS'e gömülü data YOK; kartlar Liquid'de basılı,
                    [data-research-card][hidden] olarak gelir).
   3) Modaller    : ortak aç/kapa motoru —
        AÇ   : [data-model-picker-open]            → [data-model-picker]
               [data-size-guide-open]              → [data-size-guide]
               [data-gift-modal="uyku-seti|compare|hero"]
                                                   → [data-gift-overlay]
        KAPA : [data-*-close] · arka plan tık · ESC
   Vanilla, defer ile yüklenir. Tüm global köprüler guarded.
   ============================================================ */
(function () {
  'use strict';

  var openOverlay = null;

  /* ——— Ortak overlay aç/kapa ———
     KÖK KURAL (27 Tem): body scroll-lock YOK — kilit yoksa kilitli kalma da yok.
     Scroll hapsi tamamen CSS'te: her overlay'in ::before backdrop katmanında
     touch-action:none + overscroll-behavior:contain, panelinde overscroll:contain
     (model-picker.liquid / size-guide-modal.liquid / gift-modals.liquid). */
  function open(overlay) {
    if (!overlay) return;
    if (openOverlay && openOverlay !== overlay) close(openOverlay);
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    openOverlay = overlay;
  }
  function close(overlay) {
    overlay = overlay || openOverlay;
    if (!overlay) return;
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    if (openOverlay === overlay) openOverlay = null;
  }

  /* Eski sürüm artığı: cache'teki eski JS body'yi kilitli bırakmış olabilir. */
  if (document.body.style.overflow === 'hidden') document.body.style.overflow = '';

  /* Arka plana tık → kapat (panel dışı) */
  function wireBackdrop(overlay) {
    if (!overlay) return;
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) close(overlay);
    });
  }

  var modelPicker = document.querySelector('[data-model-picker]');
  var sizeGuide = document.querySelector('[data-size-guide]');
  var giftOverlay = document.querySelector('[data-gift-overlay]');
  [modelPicker, sizeGuide, giftOverlay].forEach(wireBackdrop);

  /* ——— Model picker ——— */
  document.querySelectorAll('[data-model-picker-open]').forEach(function (btn) {
    btn.addEventListener('click', function () { open(modelPicker); });
  });
  document.querySelectorAll('[data-model-picker-close]').forEach(function (btn) {
    btn.addEventListener('click', function () { close(modelPicker); });
  });

  /* ——— Size guide ——— */
  document.querySelectorAll('[data-size-guide-open]').forEach(function (btn) {
    btn.addEventListener('click', function () { open(sizeGuide); });
  });
  document.querySelectorAll('[data-size-guide-close]').forEach(function (btn) {
    btn.addEventListener('click', function () { close(sizeGuide); });
  });

  /* ——— Gift modalları (tek overlay, çok panel) ——— */
  function showGiftPanel(key) {
    if (!giftOverlay) return;
    var panels = giftOverlay.querySelectorAll('[data-gift-panel]');
    var found = false;
    panels.forEach(function (p) {
      var match = p.getAttribute('data-gift-panel') === key;
      p.hidden = !match;
      if (match) found = true;
    });
    if (!found) return;
    var panel = giftOverlay.querySelector('.gift-modal__panel');
    if (panel) panel.classList.toggle('gift-modal__panel--wide', key === 'hero');
    open(giftOverlay);
  }
  document.querySelectorAll('[data-gift-modal]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      /* gift-card içindeki info butonu kart seçimini tetiklemesin */
      e.stopPropagation();
      showGiftPanel(btn.getAttribute('data-gift-modal'));
    });
  });
  document.querySelectorAll('[data-gift-modal-close]').forEach(function (btn) {
    btn.addEventListener('click', function () { close(giftOverlay); });
  });

  /* ESC → açık overlay'i kapat */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openOverlay) close(openOverlay);
  });

  /* ——— Accordion (opsiyonel, native <details> dışı) ——— */
  document.querySelectorAll('[data-accordion]').forEach(function (group) {
    var single = group.hasAttribute('data-accordion-single');
    var items = group.querySelectorAll('[data-accordion-item]');
    items.forEach(function (item) {
      var trigger = item.querySelector('[data-accordion-trigger]');
      var body = item.querySelector('[data-accordion-body]');
      if (!trigger || !body) return;
      body.style.overflow = 'hidden';
      body.style.maxHeight = item.classList.contains('is-open') ? body.scrollHeight + 'px' : '0';
      trigger.addEventListener('click', function () {
        var willOpen = !item.classList.contains('is-open');
        if (single && willOpen) {
          items.forEach(function (other) {
            if (other === item) return;
            other.classList.remove('is-open');
            var ob = other.querySelector('[data-accordion-body]');
            if (ob) ob.style.maxHeight = '0';
            var ot = other.querySelector('[data-accordion-trigger]');
            if (ot) ot.setAttribute('aria-expanded', 'false');
          });
        }
        item.classList.toggle('is-open', willOpen);
        body.style.maxHeight = willOpen ? body.scrollHeight + 'px' : '0';
        trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      });
    });
  });

  /* ——— Research load-more (gizli kartları aç) ——— */
  document.querySelectorAll('[data-research-more]').forEach(function (btn) {
    var scopeSel = btn.getAttribute('data-research-scope');
    var scope = scopeSel ? document.querySelector(scopeSel) : btn.previousElementSibling;
    var batch = parseInt(btn.getAttribute('data-research-batch'), 10) || 6;
    btn.addEventListener('click', function () {
      if (!scope) return;
      var hiddenCards = Array.prototype.slice.call(scope.querySelectorAll('[data-research-card][hidden]'));
      hiddenCards.slice(0, batch).forEach(function (card) {
        card.hidden = false;
        card.classList.add('is-revealing');
        requestAnimationFrame(function () { card.classList.remove('is-revealing'); });
      });
      if (!scope.querySelector('[data-research-card][hidden]')) {
        btn.style.display = 'none';
      }
    });
  });

  /* Dış erişim (buybox/içerik ajanı çağırabilir) — guarded global */
  window.MuyuPdpContent = {
    openModelPicker: function () { open(modelPicker); },
    openSizeGuide: function () { open(sizeGuide); },
    openGift: showGiftPanel,
    closeAll: function () { close(openOverlay); }
  };
})();
